<template>
  <v-tooltip right>
    <template v-slot:activator="{ on }">
      <v-icon
        class="mr-2"
        small
        v-on="on"
        @click="localValue = !localValue"
        :disabled="disabled"
        :color="localColor"
        >{{ icon }}
      </v-icon>
    </template>
    <span>{{ this.toolTip }}</span>
  </v-tooltip>
  <!--  CALL COMPONENT FROM PARENT EXAMPLE -- 
              <AthletesDropdown v-on:change-athlete="onChangeAthlete"/>
              import AthletesDropdown from "../shared/athletes_dropdown.vue";-->
</template>

<script>
export default {
  props: ["parentValue", "icon", "toolTip", "color", "disabled"],
  model: {
    prop: "parentValue",
    event: "parentValueChange"
  },
  //mixins: [getTagColor],
  data() {
    return {
      //  icon: 'fas fa-video',
    };
  },
  computed: {
    localColor() {
      return this.color ? this.color : this.localValue ? "blue" : "grey";
    },
    localValue: {
      get: function() {
        return this.parentValue;
      },
      set: function(value) {
        this.$emit("parentValueChange", value);
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
